import { startCase, uniq } from 'lodash-es'
import { Locale, Translation } from 'locale'
import { Severity, ValidationIssue, ValidationType } from 'api'
import { sliceFieldName } from 'utils'

export { ValidationType, Severity }

const errorMessages = {
  [ValidationType.MISSING_MANDATORY]: Translation.SC_MISSING_MANDATORY,
  [ValidationType.INVALID_VALUE]: Translation.SC_INVALID_VALUE
}

function getErrorMessageForType(errorType: ValidationType) {
  return Locale.translate(errorMessages[errorType] || Translation.SC_GENERIC_ERROR)
}

export function getIssuesForField(validationIssues: ValidationIssue[], fieldName: string): ValidationIssue[] {
  const finalFieldName = sliceFieldName(fieldName, -1)
  return validationIssues.filter(issue => issue.fieldName === finalFieldName)
}

export function getErrorMessages(validationIssues: ValidationIssue[]): string[] {
  return uniq(validationIssues.map(issue => issue.errorMessage || getErrorMessageForType(issue.type)))
}

export function getErrorMessagesByField(
  validationIssues: ValidationIssue[],
  getFieldNameForDisplay: (fieldName: string) => string | null = () => null
): string[] {
  return uniq(
    validationIssues.map(
      issue =>
        `${getFieldNameForDisplay(issue.fieldName) ?? startCase(issue.fieldName)}:  ${issue.errorMessage ||
          getErrorMessageForType(issue.type)}`
    )
  )
}

export function maxSeverity(validationIssues: ValidationIssue[] | undefined = []): Severity | null {
  let result: Severity | null = null

  for (let idx = 0; idx < validationIssues.length; idx++) {
    if (!result || validationIssues[idx].severity === Severity.ERROR) {
      result = validationIssues[idx].severity
    }
  }

  return result
}

export function createMissingMandatoryValidationIssue(fieldName: string): ValidationIssue {
  return {
    errorMessage: null,
    fieldName,
    severity: Severity.ERROR,
    type: ValidationType.MISSING_MANDATORY
  }
}

export function createInvalidValueValidationIssue(
  fieldName: string,
  errorMessage: string | null,
  severity: Severity = Severity.ERROR
): ValidationIssue {
  return {
    errorMessage,
    fieldName,
    severity,
    type: ValidationType.INVALID_VALUE
  }
}
